const DtmkInput = {
  props: {
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
    },
    errorMessage: {
      type: String,
      default: 'Por favor rellena este campo',
    },
  },
  template: `
    <div class="uk-margin-top">
      <label>{{ label }}</label>
      <div class="uk-form-controls">
        <input type="text" class="uk-input" :value="value" @input="$emit('input', $event.target.value)" :placeholder="placeholder">
      </div>
      <div class="uk-text-danger" v-if="error">
        {{ errorMessage }}
      </div>
    </div>
  `,
};

const DmtkRadioMaybe = {
  props: {
    label: { default: 'Especifica los requisitos' },
    placeholder: { default: '' },
    value: {
      default: '',
    },
    options: {
      default: () => {
        return ['Requerida', 'Deseable', 'No necesaria'];
      },
    },
    extra: { default: '' },
    extraActive: { default: false },
    error: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
      default: 'Por favor rellena este campo',
    },
  },
  data() {
    return {
      name: String,
    };
  },
  computed: {
    isExtraActive() {
      return (this.extraActive || this.options[0]) === this.value;
    },
  },
  created() {
    this.name = Math.random().toString(36).substring(7);
  },
  template: `
    <div>
      <div class="uk-margin-top uk-grid uk-grid-small uk-child-width-auto">
        <label v-for="option in options">
          <input class="uk-radio" type="radio"
                 :name="name" :value="option" :checked="option === value"
                 @input="$emit('value', $event.target.value)"
          />
          {{ option }}
        </label>
      </div>
      <div class="uk-text-danger" v-if="error">
        {{ errorMessage }}
      </div>
      <div class="uk-margin-top" v-if="isExtraActive">
        <label>{{ label }}</label>
        <textarea class="uk-textarea" :placeholder="placeholder" rows="3" :value="extra" @input="$emit('extra', $event.target.value)"></textarea>
      </div>
    </div>

  `,
};
